module.exports = __webpack_public_path__ + "img/diagram-nested.1e69878c.svg";